import { render, staticRenderFns } from "./ManageSpacePage.vue?vue&type=template&id=8e076d9e&"
import script from "./ManageSpacePage.vue?vue&type=script&lang=js&"
export * from "./ManageSpacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports